import { c as _c } from "react/compiler-runtime";
import { FormSelect, FormSelectProps, Hint } from '@systemeio/ui';
import { useSetDefaultSenderEmail } from 'shared/components/sender-email-select/hooks/use-set-default-sender-email';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import LinkWithoutPrefetch from '../link-without-prefetch';
import TransLoco from '../trans-loco';
export interface SenderEmailSelectProps extends Omit<FormSelectProps<string>, 'data'> {
  hintLabel?: string;
  noHint?: boolean;
}
function SenderEmailSelect(t0) {
  const $ = _c(27);
  let hintLabel;
  let noHint;
  let onChange;
  let rest;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      onChange,
      hintLabel,
      noHint,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = hintLabel;
    $[2] = noHint;
    $[3] = onChange;
    $[4] = rest;
    $[5] = value;
  } else {
    hintLabel = $[1];
    noHint = $[2];
    onChange = $[3];
    rest = $[4];
    value = $[5];
  }
  const {
    t
  } = useLocoTranslation();
  const {
    senderEmailValidList
  } = useSetDefaultSenderEmail(value, onChange);
  let t1;
  if ($[6] !== senderEmailValidList) {
    t1 = senderEmailValidList?.map(_temp);
    $[6] = senderEmailValidList;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const senderEmailOptions = t1;
  const t2 = value || "";
  let t3;
  if ($[8] !== t) {
    t3 = t("dashboard.email.sender_email_address");
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = !noHint;
  let t5;
  if ($[10] !== hintLabel || $[11] !== t) {
    t5 = hintLabel ? hintLabel : <TransLoco t={t} i18nKey="dashboard.email.add_new_email_hint" components={{
      a: <LinkWithoutPrefetch target="_blank" href="/profile/mailing-settings#verified-email-addresses" className="primary-link" />
    }} />;
    $[10] = hintLabel;
    $[11] = t;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <div>{t5}</div>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <Hint showHint={t4} label={t6} />;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t3 || $[19] !== t7) {
    t8 = <div className="flex gap-2">{t3}{t7}</div>;
    $[18] = t3;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== onChange || $[22] !== rest || $[23] !== senderEmailOptions || $[24] !== t2 || $[25] !== t8) {
    t9 = <FormSelect data={senderEmailOptions} value={t2} onChange={onChange} withoutCloseIcon={true} label={t8} {...rest} />;
    $[21] = onChange;
    $[22] = rest;
    $[23] = senderEmailOptions;
    $[24] = t2;
    $[25] = t8;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  return t9;
}
function _temp(t0) {
  const {
    email
  } = t0;
  return {
    id: email,
    caption: email
  };
}
export default SenderEmailSelect;